import { Injectable } from '@angular/core';

const DARK_MODE_CLASS = 'dark-mode';
const STORAGE_KEY = 'rag-dark-mode';

@Injectable({
  providedIn: 'root',
})
// Plumbing only: toggles the `dark-mode` body class Angular Material's theme scaffold
// (see src/styles/_theme.scss) reacts to. No dark palette is authored yet and no UI toggle
// exists yet — this exists so a future toggle control is a one-line addition.
export class ThemeService {
  init(): void {
    document.body.classList.toggle(DARK_MODE_CLASS, this.isDarkMode());
  }

  isDarkMode(): boolean {
    // No dark palette is authored yet (see class comment), so only an explicit
    // stored preference can enable it, auto-following the OS preference here
    // would set `color-scheme: dark` with none of the dark colors to back it,
    // leaving native controls like scrollbars rendered dark against a light UI.
    // Reenable later with window.matchMedia?.('(prefers-color-scheme: dark)').matches.
    return localStorage.getItem(STORAGE_KEY) === 'true';
  }

  setDarkMode(enabled: boolean): void {
    localStorage.setItem(STORAGE_KEY, String(enabled));
    document.body.classList.toggle(DARK_MODE_CLASS, enabled);
  }
}
